import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CascadeOption } from "@/shared/models/cascade-option"

interface Props {
    options: CascadeOption[]
    placeholder: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsCascadeSelect',
  props: {
    options: {},
    placeholder: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

function onChange(event: any) {
    emit("select", event.value)
}

return (_ctx: any,_cache: any) => {
  const _component_CascadeSelect = _resolveComponent("CascadeSelect")!

  return (_openBlock(), _createBlock(_component_CascadeSelect, {
    class: "p-0",
    placeholder: _ctx.placeholder,
    options: _ctx.options,
    "option-label": "name",
    "option-group-label": "name",
    "option-group-children": ['children'],
    onChange: onChange
  }, null, 8, ["placeholder", "options"]))
}
}

})